import { configureStore, combineReducers } from '@reduxjs/toolkit';
import storage from 'redux-persist/lib/storage';
import { persistStore, persistReducer } from 'redux-persist';

import settings from './Settings';

const reducers = combineReducers( {
  settings,
} );

const persistConfig = {
  key: 'sloraadyen',
  storage,
};

const persistedReducer = persistReducer( persistConfig, reducers );

export const store = configureStore( {
  reducer: persistedReducer,
  middleware: ( getDefaultMiddleware ) => getDefaultMiddleware( {
    serializableCheck: {
      ignoredActions: ['persist/PERSIST'],
    },
  } ),
} );

export const persistor = persistStore( store );
